import PageLogo from './page-logo.vue';

export default PageLogo;
